"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const icons_material_1 = require("@mui/icons-material");
const material_1 = require("@mui/material");
const iconStyling = {
    verticalAlign: "bottom",
    fontSize: 30,
    marginRight: 4,
    marginBottom: 1,
};
const Title = (0, material_1.styled)(material_1.DialogTitle)(({ theme }) => ({
    paddingTop: theme.spacing(2.5),
}));
const Actions = (0, material_1.styled)(material_1.DialogActions)(({ theme }) => ({
    paddingTop: theme.spacing(0.5),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(1),
}));
const Text = (0, material_1.styled)(material_1.DialogContentText)({
    letterSpacing: 0.25,
    minWidth: 420,
});
const SuccessIcon = (0, material_1.styled)(icons_material_1.CheckCircleOutline)(({ theme }) => ({
    color: theme.palette.success.light,
    ...iconStyling,
}));
const ErrorIcon = (0, material_1.styled)(icons_material_1.ErrorOutline)(({ theme }) => ({
    color: theme.palette.error.light,
    ...iconStyling,
}));
function DialogModal({ modalOpen, handleClose, handleConfirm, modalType, title, text, confirmButtonColor = "primary", confirmButtonLabel = "Confirm", closeButtonColor = "primary", closeButtonLabel = "Close", }) {
    let icon;
    switch (modalType) {
        case "success":
            icon = react_1.default.createElement(SuccessIcon, null);
            break;
        case "error":
            icon = react_1.default.createElement(ErrorIcon, null);
            break;
        default:
            icon = null;
    }
    return (react_1.default.createElement(material_1.Dialog, { open: modalOpen, onClose: handleClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", "data-testid": "alert-dialog-container" },
        react_1.default.createElement(Title, { id: "alert-dialog-title" },
            icon,
            title),
        react_1.default.createElement(material_1.DialogContent, null,
            react_1.default.createElement(Text, { id: "alert-dialog-description" }, text)),
        react_1.default.createElement(Actions, null,
            handleConfirm ? (react_1.default.createElement(material_1.Button, { onClick: handleConfirm, color: confirmButtonColor }, confirmButtonLabel)) : null,
            react_1.default.createElement(material_1.Button, { onClick: handleClose, color: closeButtonColor }, closeButtonLabel))));
}
exports.default = DialogModal;
